import { useRef, useState } from "react";
import { Upload, FolderOpen, Inbox } from "lucide-react";
import DocumentRow from "./DocumentRow";

// Eén map (Clubmap of Inbox): kop + upload-zone + lijst met documenten.
export default function DocumentFolderBox({ folder, title, subtitle, docs, total, filtering, perms, canManageDoc, uploading,
                                            onUpload, onDownload, onPreview, onDelete, onRelabel, onExtractLiquidity, busyId, allowedExt }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);
  const Icon = folder === "inbox" ? Inbox : FolderOpen;
  const accept = (allowedExt || []).map((e) => `.${e}`).join(",");

  const pick = (files) => { if (files?.length) onUpload(folder, Array.from(files)); };

  return (
    <section className="border-2 border-foreground bg-card heavy-shadow flex flex-col" data-testid={`doc-folder-${folder}`}>
      <div className="p-4 border-b-2 border-foreground flex items-start justify-between gap-3 flex-wrap">
        <div className="flex items-start gap-3 min-w-0">
          <div className={`w-10 h-10 border-2 border-foreground flex items-center justify-center shrink-0 ${folder === "inbox" ? "bg-accent text-accent-foreground" : "bg-primary text-primary-foreground"}`}>
            <Icon className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <h3 className="font-display font-black text-xl uppercase tracking-tight leading-tight">{title}</h3>
            <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>
          </div>
        </div>
        {perms.upload && (
          <>
            <input ref={inputRef} type="file" multiple accept={accept} className="hidden" data-testid={`doc-upload-input-${folder}`}
              onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
            <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading} data-testid={`doc-upload-btn-${folder}`}
              className="btn-brutal bg-primary text-primary-foreground px-3 py-2 font-display uppercase font-bold text-sm inline-flex items-center gap-2 disabled:opacity-40">
              <Upload className="w-4 h-4" /> {uploading ? "Uploaden…" : "Uploaden"}
            </button>
          </>
        )}
      </div>

      {perms.upload && (
        <div
          onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={(e) => { e.preventDefault(); setDragOver(false); pick(e.dataTransfer.files); }}
          data-testid={`doc-dropzone-${folder}`}
          className={`m-3 border-2 border-dashed px-3 py-3 text-center text-xs transition-colors ${dragOver ? "border-primary bg-primary/10 text-primary" : "border-foreground/40 text-muted-foreground"}`}>
          Sleep bestanden hierheen of klik op <b>Uploaden</b> · max 25 MB per bestand
        </div>
      )}

      {docs.length === 0 ? (
        <div className="p-6 text-center text-sm text-muted-foreground" data-testid={`doc-empty-${folder}`}>
          {filtering && total > 0 ? "Geen bestanden die aan je zoekopdracht of filters voldoen." : folder === "inbox" ? "Nog niets aangeleverd." : "Nog geen documenten in deze map."}
        </div>
      ) : (
        <ul className="divide-y divide-border" data-testid={`doc-list-${folder}`}>
          {docs.map((d) => (
            <DocumentRow key={d.id} doc={d} canManage={canManageDoc(d)} busy={busyId === d.id}
              onDownload={onDownload} onPreview={onPreview} onDelete={onDelete} onRelabel={onRelabel} onExtractLiquidity={onExtractLiquidity} />
          ))}
        </ul>
      )}
      <div className="px-3 py-2 border-t-2 border-foreground bg-muted/40 text-[11px] text-muted-foreground mt-auto" data-testid={`doc-count-${folder}`}>
        {filtering && total != null ? `${docs.length} van ${total} ${total === 1 ? "bestand" : "bestanden"}` : `${docs.length} ${docs.length === 1 ? "bestand" : "bestanden"}`}
      </div>
    </section>
  );
}
